import { useCallback, useEffect, useRef } from "react";
import styled from "styled-components/macro";
import { Modal, ModalContent, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import { useModal, useSettings } from "../store";

const SITE_KEY = "0x4AAAAAAARwLoiSvmfo9jCY";
const SCRIPT_ID = "turnstile-script";

const Captcha = styled.div`
  padding: 16px;
  margin: 0 auto;
`;

const loadTurnstileScript = () => {
    if (document.getElementById(SCRIPT_ID)) return Promise.resolve();

    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.id = SCRIPT_ID;
        script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
        script.async = true;
        script.defer = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
    });
};

const Turnstile = styled(({ className, onClose, resolve, reject }) => {
    const ref = useRef(null);
    const settledRef = useRef(false);
    const { theme } = useSettings();

    useEffect(() => {
        loadTurnstileScript().then(() => {
            if (ref.current) {
                window.turnstile.render(ref.current, {
                    sitekey: SITE_KEY,
                    theme,
                    callback: (token) => {
                        if (!settledRef.current) {
                            settledRef.current = true;
                            resolve(token);
                            onClose();
                        }
                    },
                    "expired-callback": () => {
                        if (!settledRef.current) {
                            settledRef.current = true;
                            reject(new Error("expired"));
                            onClose();
                        }
                    },
                });
            }
        });

        return () => {
            settledRef.current = true;
        };
    }, [theme, resolve, reject, onClose]);

    return (
        <Modal isOpen onClose={onClose} isCentered size="sm">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Beep boop?</ModalHeader>
                <Captcha>
                    <div ref={ref} className="cf-turnstile" />
                </Captcha>
            </ModalContent>
        </Modal>
    );
})``;

export const useRecaptcha = () => {
    const modal = useModal();
    return useCallback(
        () =>
            new Promise((resolve, reject) => {
                modal.push(Turnstile, { resolve, reject });
            }),
        [modal]
    );
};
